module.exports = __webpack_public_path__ + "webpc/img/logo.82b9c7a5.png";